import imgManagedIt from '../images/services/buildlab_business_systems.jpg'
import imgEngineer from '../images/services/service_details_image_1.webp'
import imgCyber from '../images/services/buildlab_cyber_security.jpg'
import imgServers from '../images/services/service_details_image_2.webp'
import imgNetworks from '../images/services/buildlab_networks.jpg'
import imgCables from '../images/services/service_details_image_3.webp'
import imgAi from '../images/services/buildlab_ai.jpg'
import imgAiWorkflows from '../images/services/buildlab_ai_workflows.jpg'
import imgMarketing from '../images/services/buildlab_marketing.jpg'
import imgEmbershore from '../images/portfolio/embershore.jpg'
import imgCncPlatform from '../images/services/buildlab_cnc_machining.jpg'

// IT Services portfolio — anonymized engagement showcases (no client names disclosed).
// Affordable-housing project work lives on the /affordable-housing page.
// Filter `category` values: managed-it | cybersecurity | cloud | ai | web
const Project = [
    // Placed first (not just appended) so it lands in ProjectSection's homepage
    // carousel, which only shows the array's first 5 entries. `link` overrides
    // the default /portfolio-details/:slug destination on both the homepage
    // carousel (ProjectSection.js) and the full /portfolio page (PortfolioPage.js)
    // — this points to the real standalone CNC Machine Builders landing page
    // instead of a portfolio-detail page that doesn't exist for it.
    {
        Id: '11',
        pImg: imgCncPlatform,
        title: 'CNC Machine Configurator & Quote-to-Cash Platform',
        slug: 'cnc-machine-configurator-quote-to-cash-platform',
        link: '/cnc-machine-builders',
        sub: 'Custom Software',
        thumb1: 'Configurator & CPQ',
        thumb2: 'ERP Integration',
        category: 'web',
        description: 'A guided machine configurator, instant quoting and auto-BOM generation, and two-way ERP sync — replacing a disconnected quote-to-cash stack for a CNC machine manufacturer.',
    },
    {
        Id: '1',
        pImg: imgManagedIt,
        title: 'Full-Stack Managed IT for a 60-Seat Professional Services Firm',
        slug: 'managed-it-professional-services-firm',
        sub: 'Managed IT',
        thumb1: 'Managed IT',
        thumb2: 'Professional Services',
        category: 'managed-it',
        description: 'Migrated a growing professional services firm onto a single managed IT plan — helpdesk, RMM monitoring, patching, and endpoint protection — replacing a patchwork of break-fix vendors with one accountable team.',
    },
    {
        Id: '2',
        pImg: imgCyber,
        title: 'Security Posture Assessment & MDR Deployment',
        slug: 'security-posture-assessment-mdr-deployment',
        sub: 'Cyber Security',
        thumb1: 'MDR & Monitoring',
        thumb2: 'Financial Services',
        category: 'cybersecurity',
        description: 'Ran a full security posture assessment for a financial-services client, then deployed managed detection and response (MDR), endpoint hardening, and continuous monitoring to close the gaps the audit surfaced.',
    },
    {
        Id: '3',
        pImg: imgNetworks,
        title: 'Microsoft 365 Migration & Cloud Backup',
        slug: 'microsoft-365-migration-cloud-backup',
        sub: 'Cloud & Infrastructure',
        thumb1: 'M365 Migration',
        thumb2: 'Growing SMB',
        category: 'cloud',
        description: 'Migrated a growing small business to Microsoft 365 with identity, SSO, and MFA configured from day one — plus automated cloud backup and recovery so nothing lives on a single laptop.',
    },
    {
        Id: '4',
        pImg: imgAi,
        title: 'AI Workflow Automation for an Operations Team',
        slug: 'ai-workflow-automation-operations-team',
        sub: 'AI Integration',
        thumb1: 'Workflow Automation',
        thumb2: 'Operations Team',
        category: 'ai',
        description: 'Mapped an operations team’s most time-consuming manual workflows, then implemented AI assistants and lightweight automation that reclaimed hours each week — paired with training so the team actually adopted it.',
    },
    {
        Id: '5',
        pImg: imgEmbershore,
        title: 'Embershore — Nonprofit Website Built in 2 Days',
        slug: 'embershore-nonprofit-website',
        sub: 'Web Development',
        thumb1: 'Built in 2 Days',
        thumb2: 'Nonprofit',
        category: 'web',
        external: 'https://www.embershore.org',
        services: 'Web Design & Development',
        timeframe: '2 days, concept to live',
        description: 'BUILDLAB designed and launched Embershore.org — a nonprofit serving people experiencing homelessness — in just two days. A clean, dignified, mobile-first site with accessible design, fast load times, clear "Get Help" and "Get Involved" calls to action, and SEO + analytics wired in from launch.',
        overview: [
            'BUILDLAB designed and launched Embershore.org — a secular nonprofit that restores dignity and stability to people experiencing homelessness — in just two days, from concept to a live, donor-ready site.',
            'Because many of the people Embershore serves access the web exclusively on a phone, often on a limited data plan, the build prioritized a fast, image-light, mobile-first experience. The "Get Help" page was treated as the real front door: service hours, address, phone, and a no-ID-required promise surface immediately, in plain language.',
        ],
        highlights: [
            'Mobile-first, image-light pages that load fast on limited data plans',
            'Accessible by default — WCAG AA, semantic HTML, keyboard and screen-reader friendly',
            'Two equal-weight calls to action: "Get Help" and "Get Involved"',
            '"Get Help" front door with hours, address, and a no-ID-required promise',
            'Privacy-friendly analytics with no third-party tracking pixels',
            'SEO foundations — metadata, sitemap, and structured content from launch',
            'Dignified, plain-language copy written at a grade 6–8 reading level',
            'Launched in two days, ready for both clients and donors',
        ],
        outcome: [
            'The result is a clean, dignified, secular site that works as hard for someone looking for a shower and a meal as it does for a donor deciding to give. Embershore went live in two days with accessibility, speed, and privacy built in from the first commit — not bolted on afterward.',
        ],
    },
    {
        Id: '10',
        pImg: imgMarketing,
        title: 'Conversion-Focused Website & SEO Program',
        slug: 'conversion-focused-website-seo-program',
        sub: 'Web & Digital',
        thumb1: 'Web & SEO',
        thumb2: 'B2B Services',
        category: 'web',
        description: 'Rebuilt a B2B services site for speed and conversion, then layered on a technical SEO and content program measured against real pipeline — not vanity metrics.',
    },
    {
        Id: '6',
        pImg: imgEngineer,
        title: 'Multi-Site Helpdesk & Endpoint Management Rollout',
        slug: 'multi-site-helpdesk-endpoint-management-rollout',
        sub: 'Managed IT',
        thumb1: 'Helpdesk & RMM',
        thumb2: 'Multi-Site Operator',
        category: 'managed-it',
        description: 'Stood up a centralized helpdesk and standardized endpoint management across multiple sites — consistent imaging, patching, and asset tracking, with one support number for every location.',
    },
    {
        Id: '7',
        pImg: imgServers,
        title: 'MFA & Email Security Hardening After a Phishing Incident',
        slug: 'mfa-email-security-hardening',
        sub: 'Cyber Security',
        thumb1: 'MFA & Email Security',
        thumb2: 'Medical Practice',
        category: 'cybersecurity',
        description: 'Responded to a phishing incident at a medical practice with rapid MFA enforcement, email security hardening, and staff security-awareness training — closing the door the attacker came through.',
    },
    {
        Id: '8',
        pImg: imgCables,
        title: 'Hybrid Infrastructure & Disaster Recovery Design',
        slug: 'hybrid-infrastructure-disaster-recovery-design',
        sub: 'Cloud & Infrastructure',
        thumb1: 'Infrastructure & DR',
        thumb2: 'Operations Team',
        category: 'cloud',
        description: 'Designed a right-sized hybrid infrastructure with tested disaster recovery — clear RTO/RPO targets, documented runbooks, and backups that are actually restorable, not just scheduled.',
    },
    {
        Id: '9',
        pImg: imgAiWorkflows,
        title: 'AI Adoption Training & Governance Rollout',
        slug: 'ai-adoption-training-governance-rollout',
        sub: 'AI Integration',
        thumb1: 'AI Enablement',
        thumb2: 'Enterprise Team',
        category: 'ai',
        description: 'Delivered hands-on AI adoption training and a governance framework — reusable prompt patterns, data-handling guardrails, and output-review process — turning ad-hoc AI use into a supported daily habit.',
    },
]

export default Project;
